import {
    Box, Button, Typography,
    Stack,
} from "@mui/material";
import { useTheme, useMediaQuery } from "@mui/material";
import { useNavigate } from "react-router-dom";
import './errors.css'
import notfound from '../../Images/home/under-maintenance.webp'
import notfound2 from '../../Images/home/under-maintenance2.webp'
import { ButtonIcons1 } from "../../Svgcollectons";
import OuterPageHeader from "../OuterPages/Header/OuterPageHeader";
import OuterPageFooter from "../OuterPages/Footer/OuterPageFooter";


const Maintenance = () => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("md"));
    const navigate = useNavigate();

    return (
        <>
            <OuterPageHeader />
            <Box
                sx={{
                    // minHeight: {xs:'80vh',md:"80vh"},
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    px: { xs: 0, sm: 0 },
                    position: 'relative',
                    zIndex: 1

                }}
            >
                <Stack
                    direction={{ xs: "column-reverse", md: "row" }}
                    spacing={{ xs: 4, md: 6 }}
                    alignItems="center"
                    justifyContent="space-between"
                    width="100%"
                    sx={{ paddingTop: { xs: '80px', md: '0px' } }}
                >

                    <Box
                        maxWidth={520}
                        textAlign={{ xs: "center", md: "left", }}
                        sx={{ position: { xs: 'relative', md: 'absolute' }, left: { xs: "auto", md: "10%" }, zIndex: 1, padding: '20px 20px 40px 20px' }}
                    >
                        <Typography className="gold-color2"
                            variant="h1"
                            fontWeight={800}
                            mb={1}
                            sx={{ fontSize: { xs: 35, md: 55 } }}
                        >
                            System Maintenance in Progress
                        </Typography>


                        <Typography
                            variant="body1"
                            color="rgba(255,255,255,0.7)"
                            mb={4}
                        >
                            This service is temporarily unavailable. Please check back shortly.
                        </Typography>

                        <div className="golden-btn">
                            <Button onClick={() => navigate('/')}
                                endIcon={<ButtonIcons1 />}
                            >
                                Go Home
                            </Button>
                        </div>
                    </Box>


                    <Box
                        component="img"
                        src={isMobile ? notfound2 : notfound}
                        alt="404 Planet"
                        sx={{
                            width: "100%",
                            height: { xs: '100%', md: '80%' },
                            display: "block",
                            margin: '0 !important'

                        }}
                    />

                </Stack>
            </Box>
            <OuterPageFooter />
        </>
    )
}

export default Maintenance;